import React from 'react'
import PropTypes from 'prop-types'
import { Popover } from 'antd'
import Provider from 'model/provider/provider'
import FacilityProfileV2 from 'model/facilities/facilityProfileV2'

import { RowWrap, TypeItem, PopoverContent } from './styled'

const EntityTypes = ({
  entity,
  sourceField,
  getTypeName = v => v,
  dataTest,
  length = 3,
  isBsmh
}) => {
  const types = entity[sourceField] || []
  const firstTypes = types.slice(0, length)
  const rest = types.slice(length)

  const restItems = (
    <PopoverContent>
      {rest.map(type => (
        <TypeItem key={type?.uid || type}>{getTypeName(type)}</TypeItem>
      ))}
    </PopoverContent>
  )

  return (
    <RowWrap data-test={dataTest}>
      {isBsmh && <TypeItem key="bsmh">BSMH</TypeItem>}
      {firstTypes.map(type => (
        <TypeItem key={type?.uid || type}>{getTypeName(type)}</TypeItem>
      ))}
      {rest?.length > 0 && (
        <Popover placement="top" content={restItems}>
          <TypeItem>+{rest.length}</TypeItem>
        </Popover>
      )}
    </RowWrap>
  )
}

EntityTypes.propTypes = {
  entity: PropTypes.oneOfType([
    PropTypes.instanceOf(Provider),
    PropTypes.instanceOf(FacilityProfileV2)
  ]).isRequired,
  sourceField: PropTypes.string.isRequired,
  getTypeName: PropTypes.func,
  length: PropTypes.number
}

export default EntityTypes
